import Magazine from './pages/magazine/magazine';

document.addEventListener('DOMContentLoaded', (e) => {
  return new Magazine();
});
